__turbopack_context__.v({
  "button": "MoodPicker-module-scss-module__yu6lUa__button",
  "buttonSelected": "MoodPicker-module-scss-module__yu6lUa__buttonSelected",
  "row": "MoodPicker-module-scss-module__yu6lUa__row",
});
